import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import stu_become_teach from "../images/stu-become-teach.png"
import averyandcera from "../images/ave&cera.JPG"
import milling from "../images/milling.jpg"

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: "transparent",
    padding: "2rem 0",
    alignItems: "center",
  },
  section: {
    display: "flex",
    alignItems: "center",
    padding: "2rem 4rem",
    flexDirection: "row",
    background: "rgba(0, 0, 0, 0.8)",
    borderRadius: theme.shape.borderRadius,
    margin: "2rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      padding: "1rem",
      textAlign: "left",
      margin: "1rem",
    },
  },
  image: {
    width: "40%",
    height: "auto",
    borderRadius: "8px",
    margin: "0 2rem",
    display: "block",
    maxWidth: "100%",
    objectFit: "cover",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      margin: "0 0 1rem 0",
    },
  },
  textContainer: {
    width: "60%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  heading: {
    color: "tomato",
    paddingBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.6rem",
    },
  },
  body: {
    color: "tan",
    "& a": {
      color: "#90caf9",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.95rem",
    },
  },
}));

const About = () => {
  const classes = useStyles();

  return (
    <Box component="div" className={classes.mainContainer}>
      {/* Section 1: Image on Left, Text on Right */}
      <Box className={classes.section}>
        <img src={stu_become_teach} alt="Description 1" className={classes.image} />
        <Box className={classes.textContainer}>
          <Typography variant="h4" className={classes.heading}>
            Education
          </Typography>
          <Typography variant="body1" className={classes.body}>
            Education comes from everywhere, some of the ways I've found the amazing teachers I have is
            through showing up at makerspaces like the sudo room, and learning from other instructors at
            the crucible. A few particularly influential teachers of mine are <a href="https://akjsdakjshd">Celeste Flores</a> who 
            taught me almost everything I know about blacksmithing. <a href='kadkjs'>Ian Wrenk</a> who taught me manual and cnc machining.
            and many more people who share their passions at every opportunity.
          </Typography>
        </Box>
      </Box>

      {/* Section 2: Image on Right, Text on Left */}
      <Box className={classes.section}>
        <Box className={classes.textContainer}>
          <Typography variant="h4" className={classes.heading}>
            Community
          </Typography>
          <Typography variant="body1" className={classes.body}>
            Makerspaces are some of the most important places to learn, grow and build. I am involved in a many as possible
            to expand my skills, network, and teach.
             <a href="https://sudoroom.org/">The Sudo Room</a> 
            , <a href="https://www.noisebridge.net/wiki/Noisebridge">Noisebridge</a>,  
            and <a href="https://www.clayandsteel.com/">Clay and Steel</a> are my current 
            makerspaces of choice since I can see that they are doing their best to make tools and skills accessible to as many 
            people as they can. These spaces all also do their best to create a welcoming Environment for people of all
            backgrounds, identities, and classes. 
          </Typography>
        </Box>
        <img src={averyandcera} alt="Description 1" className={classes.image} />   
      </Box>

      <Box className={classes.section}>
      <img src={milling} alt="Description 1" className={classes.image} />   
        <Box className={classes.textContainer}>
          <Typography variant="h4" className={classes.heading}>
            Access to Tools and Technology
          </Typography>
          <Typography variant="body1" className={classes.body}>
            Access to tools, technology, and ways to grow is becoming increasingly important in our world where jobs are rapidly
             automated. A lot of people will need to change careers fast in order to keep up with the rapidly changing world.
             Keeping places like community colleges, makerspaces, tool libraries, and job training centers accessible is critical 
             for keeping up.

             I am currently working to improve infrastructure at the sudo room, and develop curriculum
             for design for manufacturing workshops that are accessible to low income individuals. 

          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default About;
